import { RouterModule, Routes,ExtraOptions} from '@angular/router';
import { NgModule } from '@angular/core';

import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { CompanyProfileComponent} from './master-files/company-profile/company-profile.component';
import { AddSupplierComponent} from './master-files/supplier-master/add-supplier/add-supplier.component';
import { ViewSupplierComponent } from './master-files/supplier-master/view-supplier/view-supplier.component';
import { AddCustomerComponent} from './master-files/customer-master/add-customer/add-customer.component';
import { ViewCustomersComponent} from './master-files/customer-master/view-customers/view-customers.component';
import { EmployeeComponent } from './master-files/employee-master/employee/employee.component';
import { EmployeeListComponent } from './master-files/employee-master/employee-list/employee-list.component';
import { ItemComponent } from './products/item-master/item/item.component';
import { ItemListComponent } from './products/item-master/item-list/item-list.component';
import { PurchaseOrderListComponent } from './purchase/purchase-order/purchase-order-list/purchase-order-list.component';
import { PurchaseOrderComponent } from './purchase/purchase-order/purchase-order/purchase-order.component';
import { PurchaseInvoiceListComponent } from './purchase/purchase-invoice/purchase-invoice-list/purchase-invoice-list.component';
import { PurchaseInvoiceComponent } from './purchase/purchase-invoice/purchase-invoice/purchase-invoice.component';
import { PaymentListComponent } from './purchase/payment/payment-list/payment-list.component';
import { PurchaseReturnComponent } from './purchase/purchase-return/purchase-return/purchase-return.component';
import { PurchaseReturnListComponent } from './purchase/purchase-return/purchase-return-list/purchase-return-list.component';
import { PaymentComponent } from './purchase/payment/payment/payment.component';
import { QuotationComponent} from './sale/quotation/quotation/quotation.component';
import { QuotationListComponent} from './sale/quotation/quotation-list/quotation-list.component';
import { AddInvoiceComponent} from './sale/invoice/add-invoice/add-invoice.component';
import { InvoiceListComponent} from './sale/invoice/invoice-list/invoice-list.component';
import { SaleReturnComponent } from './sale/sale-return/sale-return/sale-return.component';
import { SaleReturnListComponent } from './sale/sale-return/sale-return-list/sale-return-list.component';
import { ReceiptComponent} from './sale/receipt/receipt/receipt.component';
import { ReceiptListComponent} from './sale/receipt/receipt-list/receipt-list.component';
import { ExpenseComponent } from './expenses/expense/expense/expense.component';
import { ExpenseListComponent } from './expenses/expense/expense-list/expense-list.component';
import { BankAccountListComponent } from './banks/bank-accounts/bank-account-list/bank-account-list.component';
import { ChequeListComponent } from './banks/cheques/cheque-list.component';
import { CashBankEntryListComponent } from './banks/cash-bank-entry/cash-bank-entry-list/cash-bank-entry-list.component';
import { CashFlowComponent } from './banks/cash-flow/cash-flow.component';
import { UserListComponent } from './users/users/user-list.component';
import { UsersComponent } from './users/users/users.component';
import { UserTypesComponent } from './users/user-types/user-types.component';
import { UserPermissionComponent } from './users/user-permission/user-permission.component';
import { SettingsComponent } from './settings/settings/settings.component';

import { VehicleRegisterComponent } from './master-files/vehicle-register/vehicle-register/vehicle-register.component';
import { VehicleRegisterListComponent } from './master-files/vehicle-register/vehicle-register-list/vehicle-register-list.component';

import { ResetPasswordComponent } from './users/reset-password/reset-password/reset-password.component';
import { ResetPasswordListComponent } from './users/reset-password/reset-password-list/reset-password-list.component';
import { ResetPasswordRequestComponent } from './users/reset-password-request/reset-password-request.component';
import { ChangePasswordComponent } from './settings/change-password/change-password.component';

import { BackupComponent } from './backup/backup.component';
//Reports
import { ExpensesAnalysisReportComponent } from './reports/expenses-analysis-report/expenses-analysis-report.component';
import { IncomeStatementComponent } from './reports/income-statement/income-statement.component';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { SupplierOutstandingReportComponent } from './reports/supplier-outstanding-report/supplier-outstanding-report.component';
import { CustomerOutstandingReportComponent } from './reports/customer-outstanding-report/customer-outstanding-report.component';
import { PurchaseReportComponent } from './reports/purchase-report/purchase-report.component';
import { ItemSalesReportComponent } from './reports/item-sales-report/item-sales-report.component';
import { InvoiceReportComponent } from './reports/invoice-report/invoice-report.component';

 import { AuthGuard } from './shared/guards/auth.guard';
import { PermissionListResolverService } from './shared/services/permission-list-resolver.service';






const routes: Routes = [
{ path: '', redirectTo: '/login', pathMatch:'full'},
{ path: 'login',component: LoginComponent},
{ path: 'reset-password-request',component: ResetPasswordRequestComponent},
{ path: 'reset-password',component: ResetPasswordComponent,
  canActivate : [AuthGuard]
},
{ path: 'change-password',component: ChangePasswordComponent,
  canActivate : [AuthGuard]
},
  
{
  path: 'pages',
  component: PagesComponent,
  children: [   
   { path: 'dashboard',component: DashboardComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'DB'
     }
   },
   { path: 'master-files/company-profile',component: CompanyProfileComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'COM'
     }
   },
   { path: 'master-files/supplier',component: AddSupplierComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'SM'
     }
   },
   { path: 'master-files/supplier-list',component: ViewSupplierComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'SM_LIST'
     }
   },

   { path: 'master-files/customer',component: AddCustomerComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'CM'
     }
   },
   { path: 'master-files/customer-list',component: ViewCustomersComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'CM_LIST'
     }
   },

   { path: 'master-files/employee',component: EmployeeComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'EM'
     }
   },
   { path: 'master-files/employee-list',component: EmployeeListComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'EM_LIST'
     }
   },
   { path: 'master-files/vehicle',component: VehicleRegisterComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'VH'
     }
   },
   { path: 'master-files/vehicle-list',component: VehicleRegisterListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'VH_LIST'
   }
   },
   { path: 'products/item',component: ItemComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'IM'
     }
   },
   { path: 'products/item-list',component: ItemListComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'IM_LIST'
     }
   },
 
  //  { path: 'purchase/purchase-order',component: PurchaseOrderComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/purchase-order-list',component: PurchaseOrderListComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/purchase-invoice',component: PurchaseInvoiceComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/purchase-invoice-list',component: PurchaseInvoiceListComponent,
  //  canActivate : [AuthGuard],
  //  },     
  //  { path: 'purchase/purchase-return',component: PurchaseReturnComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/purchase-return-list',component: PurchaseReturnListComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/payment',component: PaymentComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'purchase/payment-list',component: PaymentListComponent,
  //  canActivate : [AuthGuard],
  //  },
   { path: 'customer/quotation',component: QuotationComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'QT'
   }
   },
   { path: 'customer/quotation-list',component: QuotationListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'QT_LIST'
   }
   },  
   { path: 'customer/invoice',component: AddInvoiceComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'INV'
     }
   },
   { path: 'customer/invoice-list',component: InvoiceListComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'INV_LIST'
     }
   }, 
  //  { path: 'customer/sale-return',component: SaleReturnComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'customer/sale-return-list',component: SaleReturnListComponent,
  //  canActivate : [AuthGuard],
  //  },
   { path: 'customer/receipt',component: ReceiptComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RECEIPT'
  }
   },
   { path: 'customer/receipt-list',component: ReceiptListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RECEIPT_LIST'
  }
   }, 
   { path: 'expenses/expense',component: ExpenseComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'EXP'
    }
   },
   { path: 'expenses/expense-list',component: ExpenseListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'EXP_LIST'
  }
   }, 
   { path: 'cash&banks/manage-accounts',component: BankAccountListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'MACC'
   }
   },
   { path: 'cash&banks/cash&bank-entry-list',component: CashBankEntryListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'CB_ENTRY'
   }
   },
   { path: 'cash&banks/cheque-list',component: ChequeListComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'CHQ'
  }
   },
   { path: 'cash&banks/cash-flow-statement',component: CashFlowComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'CB_BAL'
  }
   },
   { path: 'user-management/user',component: UsersComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'USER'
    }
   },
   { path: 'user-management/user-list',component: UserListComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'USER'
    }
   },
   { path: 'user-management/user-types',component: UserTypesComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'USER'
  }
   },
   { path: 'user-management/user-permission',component: UserPermissionComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'USER'
  }
   },
   { path: 'user-management/reset-password-request-list',component: ResetPasswordListComponent,
    canActivate : [AuthGuard],
    data: {
      module: 'USER'
    }
   },
   { path: 'reports/customer-outstanding-report',component: CustomerOutstandingReportComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RPT_CB'
  }
   },
  //  { path: 'reports/supplier-outstanding-report',component: SupplierOutstandingReportComponent,
  //  canActivate : [AuthGuard],
  //  },
  //  { path: 'reports/purchase-report',component: PurchaseReportComponent,
  //   canActivate : [AuthGuard],
  //  },
   { path: 'reports/sales-report',component: SalesReportComponent,
    canActivate : [AuthGuard],
    data: {
      module: 'RPT_SALE'
    }
   },
   { path: 'reports/invoice-report',component: InvoiceReportComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RPT_INV'
  }
   },
  //  { path: 'reports/product-sales-report',component: ItemSalesReportComponent,
  //    canActivate : [AuthGuard],
  //  },
   { path: 'reports/expense-report',component: ExpensesAnalysisReportComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RPT_EXP'
  }
   },
   { path: 'reports/profit-and-loss-statement',component: IncomeStatementComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'RPT_PNL'
  }
   },
 
   { path: 'settings',component: SettingsComponent,
   canActivate : [AuthGuard],
   data: {
    module: 'SETTINGS'
  }
   },
   { path: 'backup',component: BackupComponent,
     canActivate : [AuthGuard],
     data: {
      module: 'BACKUP'
    }
   },

    // { path: '',  redirectTo: 'pages',
    //   pathMatch: 'full',
    //   canActivate : [AuthGuard],
    //   data: {
    //     module: 'PAGES'
    //   }
    // },
               
  ],
},

{ path: '**',redirectTo: '/login', pathMatch:'full'}

];
const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
